export default "__VITE_ASSET__C0jXJv9B__"